import React, { useEffect, useState } from 'react';
import {
  Container,
  Header,
  Image,
  Segment,
} from 'semantic-ui-react';
import axios from 'axios';
import { useParams } from 'react-router-dom';

import HelpView from '../components/HelpView';
import { useError } from '../providers/ErrorProvider';

const Help = () => {
  const [commands, setCommands] = useState({});
  const [displayName, setDisplayName] = useState(null);
  const [profileImageURL, setProfileImageURL] = useState(null);
  const { streamer } = useParams();
  const { showError } = useError();

  useEffect(() => {
    const getCommands = async () => {
      try {
        const { data } = await axios(
          streamer ? `/api/commands/${streamer}` : '/api/commands',
        );
        if (data.status === 200) {
          setCommands(data.response.commands);
          setDisplayName(data.response.display_name);
          setProfileImageURL(data.response.profile_image_url);
        }
      } catch (err) {
        showError(<center>Oops, something went wrong. Don't worry, we've been notified of the issue and will fix it as soon as possible!</center>);
      }
    }
    getCommands();
  }, [streamer, showError]);


  return (
    <Segment inverted>
      <Container text className='description'>
        <Header inverted>Commands</Header>
        <p>
          {streamer ?
            <React.Fragment>
              <p>
                <Image src={profileImageURL} avatar />
                <span>{displayName} is using the Twitching of Isaac mod!</span>
              </p>
              <p>
                Please see the available commands below with details on how to use them. When in doubt, just <strong>!fart</strong>.
              </p>
            </React.Fragment>
            :
            <p>
              Below are the default commands available in the Twitching of Isaac. Individual streamers may customize these commands with aliases for translation, as well as change commands
              to only be accessible to subscribers, via bits, or completely disable commands. To get a list of commands that will work during a stream, type !help in the streamers chat to
              get a link showing commands available on their stream.
            </p>
          }
        </p>
      </Container>


      {Object.values(commands).map((command, index) => <React.Fragment>
        {streamer && (!command.flags || command.flags === 0) ? '' :
          <HelpView command={command} streamer={streamer} />
        }
      </React.Fragment>
      )}
    </Segment>
  )
};

export default Help;
